import { makeStyles } from "@material-ui/core/styles";
import GeneralButton from "../../../../../components/1elements/Buttons/TextButtons/GeneralButton";

const Footer = ({ config: { buttons, handleClose } }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.firstHalfButtons}>
                {buttons && buttons.cancel && (
                    <GeneralButton
                        config={{
                            text: buttons.cancel.text || "Cancel",
                            onClick:
                                buttons.cancel.actionFunction || handleClose,
                            secondaryButton: true,
                        }}
                    />
                )}
            </div>
            <div className={classes.secondHalfButtons}>
                {buttons && buttons.viewData && (
                    <GeneralButton
                        config={{
                            text: buttons.viewData.text || "View Data",
                            onClick:
                                buttons.viewData.actionFunction || handleClose,
                            secondaryButton: false,
                        }}
                    />
                )}
                {buttons && buttons.actionButton && (
                    <GeneralButton
                        config={{
                            className: classes.footerButtonAction,
                            text: buttons.actionButton.text || "Save",
                            onClick:
                                buttons.actionButton.actionFunction ||
                                handleClose,
                            secondaryButton: false,
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default Footer;

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px 30px",
    },
    firstHalfButtons: {
        width: "30%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
    },
    secondHalfButtons: {
        width: "60%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    footerButtonAction: {
        marginLeft: "20px",
    },
}));
